<template>
  <div>
    <az-back-button :route="{name: 'termosConfiguracao'}" text="Voltar para listagem"></az-back-button>
    <az-container>
      <az-formbar>
        <div class="hide">
          <div class="itens"></div>
          <div class="actions"></div>
        </div>
      </az-formbar>
      <termo-dados v-model="termo" editando/>
      <div class="az-actions-form" v-az-auth="'DeclaracoesTermos.Atualizar'">
        <div class="align-left"></div>
        <div class="align-right">
          <button class="action-secundary" @click="cancelar">Cancelar</button>
          <button class="action-primary" @click.prevent="salvar">Salvar</button>
        </div>
      </div>
    </az-container>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {actionTypes} from '@/commons/constants'
import TermoDados from "@/views/configuracao/termos/TermoDados";

export default {
  name: 'TermoNovo',
  components: {TermoDados},
  data() {
    return {
      termo: {
        descricao: null,
        tipo: null,
        situacao: null
      }
    }
  },
  methods: {
    ...mapActions([actionTypes.CRIAR_TERMO_ACEITE]),
    cancelar() {
      this.$router.push({name: 'termosConfiguracao'})
    },
    redirecionarParaVisualizacao(idInserido) {
      this.$router.push({
        name: 'termoAtualizacao',
        params: {
          id: idInserido
        }
      })
    },
    async salvar() {
      const validado = await this.$validator._base.validateAll()
      if (!validado) {
        return
      }
      this.setMensagemLoading('Salvando termo...')
      const response = await this.$store.dispatch(actionTypes.CRIAR_TERMO_ACEITE, this.termo)
      this.mostrarNotificacaoSucesso("Termo criado com sucesso!")
      this.redirecionarParaVisualizacao(response.id)
    }
  }
}
</script>
